
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/equipo",
      function () {
        return require("private-next-pages/equipo/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/equipo"])
      });
    }
  